export function gridInit(){
  wrapGridItems()
  filterGridItems()
  gridLoadMore()
}

function wrapGridItems() {
  $(".grid .card, .grid .card-event, .grid .card-press, .grid .card-testimonial, .grid .card-flip").each(function(){
    $(this).nextUntil(".card, .card-event, .card-press, .card-testimonial, .card-flip").addBack().wrapAll('<div class="grid__item" />');
  });
}

function filterGridItems() {
  $('.grid__filters select').on('input', function(){
    const value = $(this).val()
    const name = $(this).attr('data-name')
    let $grid = $(this).closest('.grid__filters').next('.grid')
    let $loadmore = $grid.next('.grid__loadmore').find('a.cta')
    if($loadmore.length) {
      const slug = $(this).attr('data-slug')
      const id = $(this).find('option:selected').attr('data-id')
      $loadmore.attr('data-'+slug, id)
      $loadmore.attr('data-offset', 0)
      $loadmore.trigger('click')
    } else {
      if(value==name) {
        $grid.find('.grid__item').removeClass('hidden-' + name)
      } else {
        $grid.find('.card').each(function(){
          const $wrap = $(this).closest('.grid__item')
          const hasfilter = $(this).hasClass(value)
          $wrap.toggleClass('hidden-' + name, !hasfilter)
        })
      }
    }
  })
}

function gridLoadMore() {
  $('.grid__loadmore a.cta').each(function(){
    const noresults = $(this).attr('data-noresults')
    const $grid = $(this).closest('.grid__loadmore').prev('.grid')
    const spinner = '<div data-noresults="'+noresults+'" class="grid__spinner"></div>';
    $grid.prepend(spinner)
    $(this).closest('section.custom').addClass('custom--overflow');
    const initial = $grid.find('a.card').length
    if(initial < parseInt($(this).attr('data-offset'))) { $(this).hide() }
    $(this).click(function(e){
      e.preventDefault();
      const $cta = $(this)
      const limit = parseInt($cta.attr('data-limit'))
      let offset = parseInt($cta.attr('data-offset'))
      $grid.addClass('grid--loading')
      var data = {
        'content': $cta.attr('data-content'),
        'category': $cta.attr('data-category'),
        'area': $cta.attr('data-area'),
        'type1': $cta.attr('data-type1'),
        'challenge': $cta.attr('data-challenge'),
        'typology': $cta.attr('data-typology'),
        'topic': $cta.attr('data-topic'),
        'type2': $cta.attr('data-type2'),
        'limit': limit,
        'order': $cta.attr('data-order'),
        'date': $cta.attr('data-date'),
        'offset': offset,
      };
      $.ajax({
        url : $(this).attr('data-url'),
        data : data,
        type : 'POST',
        success : function(data){
          const loaded = $(data).filter('a.card').length
          if(loaded > 0) {
            if(offset==0) {
              $grid.html(data)
              $grid.prepend(spinner)
            } else {
              $grid.append(data)
            }
            $(".grid > .card, .grid > .card-event, .grid > .card-press, .grid > .card-testimonial, .grid > .card-flip").each(function(){
              $(this).nextUntil(".card, .card-event, .card-press, .card-testimonial, .card-flip").addBack().wrapAll('<div class="grid__item" />');
            });
            if(loaded < limit) {
              $cta.hide()
            } else {
              $cta.show()
              $cta.attr('data-offset', offset + loaded)
            }
          } else {
            if(offset==0) {
              $grid.html(spinner)
            }
            $cta.hide()
          }
          setTimeout(function() { $grid.removeClass('grid--loading') }, 500)
        },
      });
    })
  })
}
